// TODO: Figure out how we want to interact with tracker connection on web
export const CustomPermissions = {}
export const Connections = {}

export const initTerra = () => {}

export const checkAuth = () => {}

export const initConnection = () => {}

export const getDaily = () => {}

export const getActivity = () => {}

export const getSleep = () => {}

export const getNutrition = () => {}

export const getBody = () => {}

export const getMenstruation = () => {}

export const getAthlete = () => {}

export const readGlucoseData = () => {}

export const activateSensor = () => {}

export const getUserId = () => {}
